import { Component, Input, OnInit, Optional, Self, ViewChild } from '@angular/core'
import {
  AbstractControl,
  ControlValueAccessor,
  FormControl,
  FormGroupDirective,
  NgControl,
  NgForm,
} from '@angular/forms'
import { ErrorStateMatcher } from '@angular/material/core'
import { MatDatepicker, MatDatepickerInputEvent } from '@angular/material/datepicker'
import moment from 'moment'

const DATE_FORMAT = 'YYYY-MM-DD'

@Component({
  selector: 'bdg-date-field',
  templateUrl: './date-field.component.html',
  styleUrls: ['./date-field.component.scss'],
})
export class DateFieldComponent implements OnInit, ErrorStateMatcher, ControlValueAccessor {
  @Input()
  placeholder = 'dd/mm/aaaa'

  @Input()
  label: ''

  @Input()
  hint: ''

  @Input()
  filter: () => {}

  control: AbstractControl

  @Input()
  _value: string

  // representa o id do field
  @Input()
  id: string

  @ViewChild('picker')
  picker: MatDatepicker<moment.Moment>

  onChange = (_: any) => {}
  onTouch = (_?: any) => {}

  constructor(@Self() @Optional() public ngControl: NgControl) {
    if (this.ngControl) {
      this.ngControl.valueAccessor = this
    }
  }

  get value() {
    return moment(this._value, DATE_FORMAT)
  }

  set value(val) {
    this._value = moment(val).format(DATE_FORMAT)
    this.onChange(this._value)
  }

  onDateInput(event: MatDatepickerInputEvent<moment.Moment>) {
    this.value = moment(event.value, DATE_FORMAT, true)
    this.onTouch()
  }

  writeValue(value: any) {
    if (value) {
      this.value = moment(value, DATE_FORMAT, true)
    } else {
      this._value = value
    }
  }

  registerOnChange(fn: (_: any) => void) {
    this.onChange = fn
  }

  registerOnTouched(fn: (_?: any) => void) {
    this.onTouch = fn
  }

  ngOnInit(): void {
    this.placeholder = this.placeholder || 'dd/mm/aaaa'
    this.control = this.ngControl?.control
  }

  error() {
    return this.control && this.control.touched && this.control.errors?.error
  }

  isErrorState(_: FormControl, form: FormGroupDirective | NgForm): boolean {
    return this.error()
  }

  get matcher() {
    return this as ErrorStateMatcher
  }

  onBlur() {
    const controlValue = this.control.value
    if (this._value === 'Invalid date' || !controlValue) {
      this.control.setValue('')
    }
    this.onTouch()
  }

  onPickerClicked() {
    this.picker.open()
  }
}
